import { lazyRouteComponent } from 'src/lib/routing';
import { TooltipProvider } from '@askable/ui/core/tooltip';
import { HelmetProvider } from 'react-helmet-async';

import { RequireAuth } from 'containers/Auth/RequireAuth';

import type { RouteObject } from 'src/lib/routing';

const DiscoverContainer = lazyRouteComponent(() => import('./DiscoverContainer'), 'DiscoverContainer');

export const discoverRoutes: RouteObject[] = [
  {
    path: 'discover',
    element: (
      <RequireAuth>
        <HelmetProvider>
          <TooltipProvider>
            <DiscoverContainer />
          </TooltipProvider>
        </HelmetProvider>
      </RequireAuth>
    ),
  },
];
